import { useReducer, useState } from "react";
import IcConnecting from "@/assets/images/ic_connecting.png";
import IcConnect from "@/assets/svg/ic_connect.svg?react";
import IcCloseCircle from "@/assets/svg/ic_close_circle.svg?react";
import { connectMeeting } from '@/services/api_collaboration';
import IMG_CONNECT from "@/assets/flow/img_connect.png";
import { useNavigate } from "react-router-dom";
// import { ScreenShareApis, ScreenShareRecorder, WifiInfo } from "@core/ability";
// import WifiHandler from "@/utils/wifiHandler";
import deviceStore from '@/store/device.store';

interface IProp {
    linkType: 'LocalLink' | 'ControlLink';
    showTips?: boolean;
    // screenShareRecorder: ScreenShareRecorder;
    onConnectSuccess?: (isStart: boolean, streamName?: string) => void;
    loading?: boolean;
}

enum ConnectorState {
    Disabled = "disabled",
    Ready = "ready",
    Connecting = "connecting",
    Error = "error",
}

interface ConnectState {
    status: ConnectorState;
    code: string;
    errorMsg: string;
}

const initialState: ConnectState = {
    status: ConnectorState.Disabled,
    code: "",
    errorMsg: "",
};

const connectReducer = (state: ConnectState, action: Partial<ConnectState>) => {
    return { ...state, ...action }
};

// const INTERVAL_SCAN_TIME = 10 * 1000;

// let deviceList: WifiInfo[] = [];

// let scanInterval: NodeJS.Timeout | number | undefined = undefined;

export default function MeetingLinkView(prop: IProp) {
    const navigate = useNavigate();
    const { linkType, showTips = true, onConnectSuccess, loading } = prop;
    const [connectState, dispatch] = useReducer(connectReducer, initialState);

    const { status, code, errorMsg } = connectState;

    const [isComposition, setIsComposition] = useState(false);

    // useEffect(() => {
    //     if (linkType === 'LocalLink') {
    //         scanDevices();
    //         initTimer();
    //         return () => {
    //             scanInterval && clearInterval(scanInterval);
    //         }
    //     }
    // }, []);

    // const initTimer = () => {
    //     scanInterval = setInterval(scanDevices, INTERVAL_SCAN_TIME);
    // }

    // const scanDevices = async () => {
    //     console.log('>>> scanDevices');
    //     const res = await ScreenShareApis.scanDevices();
    //     if (!res.data.length) return;

    //     const wifiInfos: WifiInfo[] = Object.values(res.data);
    //     const wifiList = WifiHandler.filterWifiList(
    //         WifiHandler.sortWifiListWithRssi(wifiInfos)
    //     );
    //     deviceList = wifiList;
    // };

    const handleEnter = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key !== "Enter") return;
        if (status === ConnectorState.Connecting || loading) return;
        if (status === ConnectorState.Disabled) {
            console.log('输入格式不对，返回');
            return;
        }

        e.currentTarget.blur();
        handleConnect();
    };

    const handleConnect = async () => {
        if (status !== ConnectorState.Ready) return;
        if (linkType === 'ControlLink') {
            _controlConnect();
        } else {
            _localConnect();
        }
    };

    const _controlConnect = async () => {
        if (status !== ConnectorState.Ready) return;
        dispatch({ status: ConnectorState.Connecting, errorMsg: "" });

        const result = await deviceStore.getState().connectDeviceByCode(code);
        if (result.success) {
            dispatch({ status: ConnectorState.Ready });
            onConnectSuccess && onConnectSuccess(result.isRecording || false, result.streamName);
        } else {
            dispatch({ status: ConnectorState.Error, errorMsg: result.errorMsg || "连接失败" });
        }
    }

    const _localConnect = async () => {
        // const device = deviceList.find((device) => device.pinCode === code);
        console.log('localConnect');
        try {
            dispatch({ status: ConnectorState.Connecting, errorMsg: "" });
            // await prop.screenShareRecorder.connectDevice(device, code);
            const res = await connectMeeting(code);
            // await prop.screenShareRecorder.handleDisconnect();
            if (res) {
                navigate({ pathname: "/collaboration", search: `?streamId=${res.streamName!.replace("live/", "")}` });
                console.log('开始同步会议');
            } else {
                dispatch({ status: ConnectorState.Error, errorMsg: "连接会议失败" });
            }
        } catch (error) {
            const errMsg = (error as any)?.message || "设备连接失败"
            dispatch({ status: ConnectorState.Error, errorMsg: errMsg });
        }
    }

    const handleClear = () => {
        dispatch({
            code: "",
            status: ConnectorState.Disabled,
            errorMsg: "",
        });
    };

    const handleCompositionStart = () => {
        setIsComposition(true);
    };

    const handleCompositionEnd = (e: React.CompositionEvent<HTMLInputElement>) => {
        setIsComposition(false);
        const target = e.target as HTMLInputElement;
        innerChange(target.value);
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        dispatch({ code: value });
        if (!isComposition) {
            innerChange(value);
        }
    };

    const innerChange = (value: string) => {
        const code = value.toUpperCase().replace(/[^a-zA-Z0-9]/g, "");
        if (code.length === 0) {
            dispatch({ code: "" });
            return;
        }
        const codeStatus =
            code.length === 6 || code.length === 8
                ? ConnectorState.Ready
                : ConnectorState.Disabled;
        dispatch({ status: codeStatus, code, errorMsg: " " });
    };

    return (
        <div className="flex flex-col flex-1 items-center">
            {showTips && <>
                <img className="w-75 h-42.5 mt-6" src={IMG_CONNECT} />
                <span className="mt-3 text-size-3.5 text-#626773CC">加入获取实时总结、关键画面、智能问答</span>
            </>}
            <div className="mt-8 w-75 h-12.5 flex items-center rounded-full border border-solid border-#CED2D9 pl-2" >
                <div className="relative flex-1 h-full">
                    {!code && (
                        <input
                            type="text"
                            readOnly
                            placeholder="请输入大屏上的连接码"
                            className="code-input placeholder-#CED2D9 focus:outline-none"
                        />
                    )}
                    <input
                        type="text"
                        className="code-input tracking-1.5 c-mx-primary focus:outline-none placeholder-#ccccc"
                        spellCheck={false}
                        maxLength={8}
                        value={code}
                        onCompositionStart={handleCompositionStart}
                        onCompositionEnd={handleCompositionEnd}
                        onChange={handleChange}
                        onKeyUp={handleEnter}
                        tabIndex={-1}
                        autoFocus
                    />
                </div>
                {status === ConnectorState.Error && (
                    <IcCloseCircle
                        className="w-3 h-3 m-r-3 cursor-pointer"
                        onClick={handleClear}
                    />
                )}
                <div
                    className={`w-7.5 h-7.5 min-w-7.5 m-r-2.5 rounded-full  ${status === ConnectorState.Disabled
                        ? "bg-mx-primary op-60"
                        : status === ConnectorState.Ready ||
                            status === ConnectorState.Connecting || loading
                            ? "bg-#4981F2 cursor-pointer"
                            : status === ConnectorState.Error
                                ? "bg-#FF584C"
                                : ""
                        }`}
                    onClick={handleConnect}
                >
                    {status === ConnectorState.Connecting || loading ?
                        <img className="w-7.5 h-7.5 animate-spin" src={IcConnecting} /> : <IcConnect className="w-7.5 h-7.5" />
                    }
                </div>
            </div>
            {status === ConnectorState.Error && (
                <div className="m-t-2 text-center text-#FF584C text-3 line-height-4.25">
                    {errorMsg}
                </div>
            )}
        </div>
    );
}